/* eslint-disable no-unused-vars */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Edit } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo1.png";

import Parcel from "views/SubSignature/Parcel2567";
import GeneralAdministration from "views/SubSignature/GeneralAdministration2567.js";
import Pharmacy from "views/SubSignature/Pharmacy2567.js";
import Pathology from "views/SubSignature/Pathology2567.js";
import Rehab from "views/SubSignature/Rehab2567";
import Psychology from "views/SubSignature/Psychology2567";
import Welfare from "views/SubSignature/Welfare2567";
import Policy from "views/SubSignature/Policy2567";
import NursingScience from "views/SubSignature/NursingScience2567.js";
import OPD from "views/SubSignature/OPD2567.js";
import IPD from "views/SubSignature/IPD2567.js";
import Research from "views/SubSignature/Research2567.js";
import Digital from "views/SubSignature/Digital2567.js";
import HealthInsurance from "views/SubSignature/HealthInsurance2567.js";
import Quality from "views/SubSignature/Quality2567.js";
import HumanResources from "views/SubSignature/HumanResources2567";
import StrategyPlans from "views/SubSignature/StrategyPlans2567";


let ps;

const routes = [
  {
    name: "หัวหน้ากลุ่มงานการเงิน บัญชีและพัสดุ",
    icon: Edit,
    component: Parcel,
    layout: "/subsignature",
    path: "/parcel"
  },
  {
    name: "หัวหน้างานบริหารทั่วไป",
    icon: Edit,
    component: GeneralAdministration,
    layout: "/subsignature",
    path: "/generaladministration"
  },
  {
    name: "หัวหน้างานทรัพยากรบุคคล",
    icon: Edit,
    component: HumanResources,
    layout: "/subsignature",
    path: "/humanresources"
  },
  {
    name: "หัวหน้างานยุทธศาสตร์และแผนงาน",
    icon: Edit,
    component: StrategyPlans,
    layout: "/subsignature",
    path: "/strategyplans"
  },
  // {
  //       name: "กลุ่มงานเวชศาสตร์สารเสพติด",
  //       icon: Edit,
  //       component: Pathology,
  //       layout: "/subsignature",
  //       path: "/pathology"
  // },
    // {
    //     name: "กลุ่มงานฟื้นฟูสมรรถภาพ",
    //     icon: Edit,
    //     component: Rehab,
    //     layout: "/subsignature",
    //     path: "/rehab"
    // },
  {
    name: "กลุ่มงานเภสัชกรรม",
    icon: Edit,
    component: Pharmacy,
    layout: "/subsignature",
    path: "/pharmacy"
    },
    // {
    //     name: "กลุ่มงานจิตวิทยา",
    //     icon: Edit,
    //     component: Psychology,
    //     layout: "/subsignature",
    //     path: "/psychology"
    // },
    // {
    //     name: "กลุ่มงานสังคมสงเคราะห์ทางการแพทย์",
    //     icon: Edit,
    //     component: Welfare,
    //     layout: "/subsignature",
    //     path: "/welfare"
    // },
  {
    name: "กลุ่มงานวิชาการพยาบาล",
    icon: Edit,
    component: NursingScience,
    layout: "/subsignature",
    path: "/nursingscience"
  },
  // {
  //   name: "กลุ่มงานการพยาบาลผู้ป่วยนอก",
  //   icon: Edit,
  //   component: OPD,
  //   layout: "/subsignature",
  //   path: "/opd"
  // },
  {
    name: "กลุ่มงานการพยาบาลผู้ป่วยใน",
    icon: Edit,
    component: IPD,
    layout: "/subsignature",
    path: "/ipd"
    },
    // {
    //     name: "กลุ่มงานประกันสุขภาพ ",
    //     icon: Edit,
    //     component: HealthInsurance,
    //     layout: "/subsignature",
    //     path: "/healthinsurance"
    // },
    {
        name: "กลุ่มงานดิจิทัลการแพทย์",
        icon: Edit,
        component: Digital,
        layout: "/subsignature",
        path: "/digital"
    },
    {
        name: "กลุ่มงานวิจัย ถ่ายทอด และสนับสนุนวิชาการ",
        icon: Edit,
        component: Research,
        layout: "/subsignature",
        path: "/research"
    },
    {
        name: "กลุ่มงานพัฒนาคุณภาพ",
        icon: Edit,
        component: Quality,
        layout: "/subsignature",
        path: "/quality"
    },
    {
        name: "กลุ่มงานพัฒนานโยบายและยุทธศาสตร์การแพทย์",
        icon: Edit,
        component: Policy,
        layout: "/subsignature",
        path: "/policy"
    },
  {
    name: "การลงนามคำรับรอง ฯ รองผู้อำนวยการ",
    icon: DesktopWindows,
    layout: "/signature",
    path: ""
  }
];

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/subsignature" to="/subsignature" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function SubSignature({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"การลงนามคำรับรองฯ"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
